import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import "./Badge.css";

export type BadgeTone = "neutral" | "accent" | "success" | "warning" | "danger" | "info";
export type BadgeVariant = "subtle" | "outline" | "solid";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  variant?: BadgeVariant;
  /** Leading icon; status badges should carry an icon or explicit text, never colour alone. */
  icon?: ReactNode;
}

/** Small inline label for counts, states and categories. */
export function Badge({
  tone = "neutral",
  variant = "subtle",
  icon,
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cx("ui-badge", `ui-badge--${tone}`, `ui-badge--${variant}`, className)}
      {...rest}
    >
      {icon ? (
        <span className="ui-badge__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {children}
    </span>
  );
}
